import AIProviderGrid from "@/components/ai-provider-grid";
import BaseLayout from "@/components/base-layout";
import BrandCloud from "@/components/brand-cloud";
import { Header } from "@/components/header";
import FAQSection from "@/components/sections/faq";
import PricingSection from "@/components/sections/pricing";
import TestimonialsSection from "@/components/testimonial";

export default function Home() {
  return (
    <BaseLayout>
      <Header
        title="Promptwatch Pricing Plans - AI SEO/GEO Monitoring & Optimization | Promptwatch.com"
        description="Choose the perfect AI SEO/GEO monitoring plan for your business. Start with a 7-day free trial and access powerful tools to track your AI search performance, optimize for LLMs like ChatGPT and Claude, and get actionable insights. Flexible pricing for agencies, enterprises, and growing businesses."
      />
      <main className="overflow-x-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-200/50 via-blue-100/50" />
        <div
          aria-hidden="true"
          className="absolute h-full w-full scale-[0.8] bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#fff_70%,transparent_100%)]"
        />
        <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-b from-primary-600" />
        <div className="absolute h-full w-full scale-[0.8] bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#fff_70%,transparent_100%)]" />

        <section className="relative  border-gray-950/[0.07]">
          <div className="relative mx-auto max-w-6xl border-x border-gray-950/[0.07] px-4 sm:px-6 md:px-12">
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 -left-1 size-2 border shadow-sm z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 left-3 size-2 border shadow-sm sm:left-5 md:left-11 z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 -right-1 size-2 border shadow-sm z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 right-3 size-2 border shadow-sm sm:right-5 md:right-11 z-40" />
            <div className="relative border-x border-gray-950/[0.07] px-4 pb-16 pt-16 sm:px-12">
              <div className="relative w-fit bg-gray-950/5 p-2 mb-6">
                <div aria-hidden="true" className="absolute left-1 top-1 size-[3px] rounded-full bg-gray-950/20" />
                <div aria-hidden="true" className="absolute right-1 top-1 size-[3px] rounded-full bg-gray-950/20" />
                <div aria-hidden="true" className="absolute bottom-1 left-1 size-[3px] rounded-full bg-gray-950/20" />
                <div aria-hidden="true" className="absolute bottom-1 right-1 size-[3px] rounded-full bg-gray-950/20" />
                <div className="relative flex h-fit items-center gap-2 rounded-full bg-white px-3 py-1 shadow">
                  <span className="text-title text-sm flex items-center gap-2 px-1">Pricing Plans</span>
                </div>
              </div>

              <h1 className="text-title mt-6 text-4xl font-medium max-w-2xl text-left sm:mt-12 sm:text-5xl lg:text-5xl">
                Start monitoring your <span className="text-primary underline font-semibold">AI SEO performance</span>
              </h1>

              <p className="text-lg pt-8 max-w-3xl text-left text-muted-foreground">
                Start your 7-day free trial and discover the power of AI SEO optimization. Choose from flexible plans designed to scale with
                your business, featuring advanced AI tools, priority support, and enterprise-grade capabilities.
              </p>

              <AIProviderGrid />
            </div>
          </div>
        </section>

        <PricingSection showHeaderText={false} />

        <section className="border-b">
          <div className="mx-auto max-w-6xl border-x py-5">
            <div className="p-10 px-0 z-10 relative px-3 ">
              <div className="text-body text-center text-sm font-medium">Trusted by 500+ Companies & Agencies</div>
              <BrandCloud />
            </div>

            <div className="pb-12 pt-20 border-t border-gray-950/[0.07]">
              <TestimonialsSection
                testimonial={
                  <p className="font-medium text-muted-foreground">
                    With the growing demand for <span className="font-semibold text-black">GEO visibility</span> for our clients, we have
                    been searching for a tool that can provide actionable information. Promptwatch has enabled us to{" "}
                    <span className="font-semibold text-black">understand what LLM platforms are looking for</span> and how are they using
                    our clients' content.
                  </p>
                }
                author="Jimmy Park"
                company="Head of Search at Opascope"
                avatar="/people/jimmy.jpeg"
              />
            </div>
          </div>
        </section>

        <section className="relative border-b overflow-hidden border-gray-950/[0.07]">
          <div className="relative mx-auto max-w-6xl border-x border-gray-950/[0.07] px-4 sm:px-6 md:px-12">
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 -left-1 size-2 border shadow-sm z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 left-3 size-2 border shadow-sm sm:left-5 md:left-11 z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 -right-1 size-2 border shadow-sm z-40" />
            <div aria-hidden="true" className="bg-ui absolute -bottom-1 right-3 size-2 border shadow-sm sm:right-5 md:right-11 z-40" />
            <div className="relative border-x border-gray-950/[0.07] px-4 pb-16 pt-16 sm:px-12">
              <FAQSection />
            </div>
          </div>
        </section>
      </main>
    </BaseLayout>
  );
}
